<div class="login-container">
  <!-- Show user info when logged in -->
  <div *ngIf="user" class="user-info">
    <div class="user-avatar">
      <img [src]="user.picture" [alt]="user.name" *ngIf="user.picture">
      <div class="avatar-placeholder" *ngIf="!user.picture">
        {{ getUserDisplayName().charAt(0).toUpperCase() }}
      </div>
    </div>
    <div class="user-details">
      <span class="user-name">{{ getUserDisplayName() }}</span>
      <span class="user-role" *ngIf="user.role">{{ user.role }}</span>
    </div>
    <button class="logout-btn" (click)="logout()">
      <span>Sign Out</span>
    </button>
  </div>

  <!-- Show Google Sign-in button when not logged in -->
  <div *ngIf="!user" class="signin-wrapper">
    <div id="google-signin-button{{ buttonIdSuffix }}"></div>
  </div>
</div>
